import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip);

interface SparklineProps {
  data: number[];
  labels: string[];
  hoveredMonth: string | null;
  onHover: (label: string | null) => void;
}

const Sparkline: React.FC<SparklineProps> = ({ data, labels, hoveredMonth, onHover }) => {
  if (!data || data.length === 0) {
    return null;
  }

  const maxVal = Math.max(...data);
  const minVal = Math.min(...data.filter(d => d > 0));

  const pointColors = data.map(d => {
    if (d === maxVal) return 'rgba(40, 167, 69, 1)'; // Green for max
    if (d === minVal) return 'rgba(220, 53, 69, 1)';  // Red for min
    return 'transparent';
  });

  const pointRadii = data.map((_, index) => {
    if (labels[index] === hoveredMonth) return 5;
    if (data[index] === maxVal || data[index] === minVal) return 3;
    return 0;
  });

  const chartData = {
    labels,
    datasets: [
      {
        data: data,
        borderColor: 'rgba(108, 117, 125, 0.7)',
        borderWidth: 2,
        pointBackgroundColor: pointColors,
        pointRadius: pointRadii,
        pointHoverRadius: 5,
        tension: 0.4,
        fill: false,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        display: false,
      },
      y: {
        display: false,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        mode: 'index' as const,
        intersect: false,
        callbacks: {
          title: (context: any) => context[0]?.label || '',
          label: (context: any) => `Sales: ${context.raw.toLocaleString()}`,
        },
      },
    },
    onHover: (event: any, chartElement: any) => {
      if (chartElement.length) {
        onHover(labels[chartElement[0].index]);
      } else {
        onHover(null);
      }
    },
    elements: {
      line: {
        borderWidth: 2,
      },
      point: {
        radius: 0,
      }
    }
  };

  return (
    <div style={{ height: '50px', width: '150px' }}>
      <Line 
        data={chartData} 
        options={options} 
        />
    </div>
  );
};

export default Sparkline; 